import { QUICK_FIND_OPTIONS } from 'components/utils/constants';

export const QUICK_FIND_SET_DROPDOWN_OPEN = 'redux/quickFind/QUICK_FIND_SET_DROPDOWN_OPEN';
export const QUICK_FIND_SET_SELECTED = 'redux/quickFind/QUICK_FIND_SET_SELECTED';
export const QUICK_FIND_SET_COLUMN_OPEN = 'redux/quickFind/QUICK_FIND_SET_COLUMN_OPEN';
export const QUICK_FIND_SET_COLUMN_OPTIONS = 'redux/quickFind/QUICK_FIND_SET_COLUMN_OPTIONS';
export const QUICK_FIND_RESET = 'redux/quickFind/RESET_QUICK_FIND';

export const initialState = {
  dropdownOpen: false,
  columns: {
    1: { open: true, selected: '', options: QUICK_FIND_OPTIONS.firstColumn },
    2: { open: false, selected: '', options: QUICK_FIND_OPTIONS.secondColumn },
    3: { open: false, selected: '', options: [] },
  },
};

const quickFind = (state = initialState, action) => {
  switch (action.type) {
    case QUICK_FIND_SET_DROPDOWN_OPEN:
      return {
        ...state,
        dropdownOpen: action.data.open,
      };
    case QUICK_FIND_SET_SELECTED:
      return {
        ...state,
        columns: {
          ...state.columns,
          [action.data.column]: {
            ...state.columns[action.data.column],
            selected: action.data.selected,
          },
        },
      };
    case QUICK_FIND_SET_COLUMN_OPEN:
      return {
        ...state,
        columns: {
          ...state.columns,
          [action.data.column]: {
            ...state.columns[action.data.column],
            open: action.data.open,
          },
        },
      };
    case QUICK_FIND_SET_COLUMN_OPTIONS:
      return {
        ...state,
        columns: {
          ...state.columns,
          [action.data.column]: {
            ...state.columns[action.data.column],
            options: action.data.options,
          },
        },
      };
    case QUICK_FIND_RESET:
      return { ...initialState };
    default:
      return state;
  }
};

export default quickFind;
